var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationMockupsMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 200,
    viewBox: "0 0 281 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_395)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.104 2.7063H8.11926C5.1299 2.7063 2.70654 5.12966 2.70654 8.11902V159.675C2.70654 162.665 5.1299 165.088 8.11926 165.088H257.104C260.094 165.088 262.517 162.665 262.517 159.675V8.11902C262.517 5.12966 260.094 2.7063 257.104 2.7063Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.104 2.7063H8.11926C5.1299 2.7063 2.70654 5.12966 2.70654 8.11902V159.675C2.70654 162.665 5.1299 165.088 8.11926 165.088H257.104C260.094 165.088 262.517 162.665 262.517 159.675V8.11902C262.517 5.12966 260.094 2.7063 257.104 2.7063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11926 2.7063H257.104C260.094 2.7063 262.517 5.12957 262.517 8.11902V20.027H2.70654V8.11902C2.70654 5.12957 5.12982 2.7063 8.11926 2.7063Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.11926 2.7063H257.104C260.094 2.7063 262.517 5.12957 262.517 8.11902V20.027H2.70654V8.11902C2.70654 5.12957 5.12982 2.7063 8.11926 2.7063Z",
    fill: "#00252E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9664 8.11902H23.5456C22.7982 8.11902 22.1924 8.72486 22.1924 9.4722V13.2611C22.1924 14.0084 22.7982 14.6143 23.5456 14.6143H74.9664C75.7138 14.6143 76.3196 14.0084 76.3196 13.2611V9.4722C76.3196 8.72486 75.7138 8.11902 74.9664 8.11902Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.655 8.66028H237.077C236.778 8.66028 236.536 8.90261 236.536 9.20155C236.536 9.50049 236.778 9.74282 237.077 9.74282H244.655C244.954 9.74282 245.196 9.50049 245.196 9.20155C245.196 8.90261 244.954 8.66028 244.655 8.66028Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.655 10.8253H237.077C236.778 10.8253 236.536 11.0677 236.536 11.3666C236.536 11.6655 236.778 11.9079 237.077 11.9079H244.655C244.954 11.9079 245.196 11.6655 245.196 11.3666C245.196 11.0677 244.954 10.8253 244.655 10.8253Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.655 12.9905H237.077C236.778 12.9905 236.536 13.2328 236.536 13.5318C236.536 13.8307 236.778 14.073 237.077 14.073H244.655C244.954 14.073 245.196 13.8307 245.196 13.5318C245.196 13.2328 244.954 12.9905 244.655 12.9905Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1829 66.0351C42.3574 66.0351 48.1734 60.2191 48.1734 53.0446C48.1734 45.8701 42.3574 40.0541 35.1829 40.0541C28.0084 40.0541 22.1924 45.8701 22.1924 53.0446C22.1924 60.2191 28.0084 66.0351 35.1829 66.0351Z",
    fill: "url(#paint0_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6403 43.3018H64.141C63.6926 43.3018 63.3291 43.6653 63.3291 44.1137V46.82C63.3291 47.2684 63.6926 47.6319 64.141 47.6319H93.6403C94.0887 47.6319 94.4522 47.2684 94.4522 46.82V44.1137C94.4522 43.6653 94.0887 43.3018 93.6403 43.3018Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.772 51.9622H64.141C63.6926 51.9622 63.3291 52.3257 63.3291 52.7741V53.3153C63.3291 53.7637 63.6926 54.1272 64.141 54.1272H170.772C171.22 54.1272 171.583 53.7637 171.583 53.3153V52.7741C171.583 52.3257 171.22 51.9622 170.772 51.9622Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.75 56.2922H64.141C63.6926 56.2922 63.3291 56.6557 63.3291 57.1041V57.6454C63.3291 58.0938 63.6926 58.4573 64.141 58.4573H161.75C162.199 58.4573 162.562 58.0938 162.562 57.6454V57.1041C162.562 56.6557 162.199 56.2922 161.75 56.2922Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.729 60.6224H64.141C63.6926 60.6224 63.3291 60.9859 63.3291 61.4343V61.9756C63.3291 62.424 63.6926 62.7875 64.141 62.7875H152.729C153.178 62.7875 153.541 62.424 153.541 61.9756V61.4343C153.541 60.9859 153.178 60.6224 152.729 60.6224Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.822 56.2923C189.615 56.2923 191.069 54.8382 191.069 53.0446C191.069 51.251 189.615 49.797 187.822 49.797C186.028 49.797 184.574 51.251 184.574 53.0446C184.574 54.8382 186.028 56.2923 187.822 56.2923Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.143 56.2923C206.936 56.2923 208.39 54.8382 208.39 53.0446C208.39 51.251 206.936 49.797 205.143 49.797C203.349 49.797 201.895 51.251 201.895 53.0446C201.895 54.8382 203.349 56.2923 205.143 56.2923Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.482 56.2923C198.276 56.2923 199.73 54.8382 199.73 53.0446C199.73 51.251 198.276 49.797 196.482 49.797C194.688 49.797 193.234 51.251 193.234 53.0446C193.234 54.8382 194.688 56.2923 196.482 56.2923Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.803 56.2923C215.596 56.2923 217.05 54.8382 217.05 53.0446C217.05 51.251 215.596 49.797 213.803 49.797C212.009 49.797 210.555 51.251 210.555 53.0446C210.555 54.8382 212.009 56.2923 213.803 56.2923Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.463 56.2923C224.257 56.2923 225.711 54.8382 225.711 53.0446C225.711 51.251 224.257 49.797 222.463 49.797C220.67 49.797 219.216 51.251 219.216 53.0446C219.216 54.8382 220.67 56.2923 222.463 56.2923Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.371 101.218C41.0971 101.218 46.5496 95.7653 46.5496 89.0392C46.5496 82.3132 41.0971 76.8606 34.371 76.8606C27.6449 76.8606 22.1924 82.3132 22.1924 89.0392C22.1924 95.7653 27.6449 101.218 34.371 101.218Z",
    fill: "url(#paint1_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8283 79.2963H63.329C62.8806 79.2963 62.5171 79.6598 62.5171 80.1082V82.8145C62.5171 83.2629 62.8806 83.6264 63.329 83.6264H92.8283C93.2767 83.6264 93.6402 83.2629 93.6402 82.8145V80.1082C93.6402 79.6598 93.2767 79.2963 92.8283 79.2963Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.96 87.9567H63.329C62.8806 87.9567 62.5171 88.3202 62.5171 88.7686V89.3098C62.5171 89.7583 62.8806 90.1218 63.329 90.1218H169.96C170.408 90.1218 170.772 89.7583 170.772 89.3098V88.7686C170.772 88.3202 170.408 87.9567 169.96 87.9567Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 92.2867H63.329C62.8806 92.2867 62.5171 92.6502 62.5171 93.0987V93.6399C62.5171 94.0883 62.8806 94.4518 63.329 94.4518H160.938C161.387 94.4518 161.75 94.0883 161.75 93.6399V93.0987C161.75 92.6502 161.387 92.2867 160.938 92.2867Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.917 96.6169H63.329C62.8806 96.6169 62.5171 96.9804 62.5171 97.4289V97.9701C62.5171 98.4185 62.8806 98.782 63.329 98.782H151.917C152.365 98.782 152.729 98.4185 152.729 97.9701V97.4289C152.729 96.9804 152.365 96.6169 151.917 96.6169Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.01 92.2869C188.803 92.2869 190.257 90.8329 190.257 89.0393C190.257 87.2456 188.803 85.7916 187.01 85.7916C185.216 85.7916 183.762 87.2456 183.762 89.0393C183.762 90.8329 185.216 92.2869 187.01 92.2869Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.331 92.2869C206.124 92.2869 207.578 90.8329 207.578 89.0393C207.578 87.2456 206.124 85.7916 204.331 85.7916C202.537 85.7916 201.083 87.2456 201.083 89.0393C201.083 90.8329 202.537 92.2869 204.331 92.2869Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.67 92.2869C197.464 92.2869 198.918 90.8329 198.918 89.0393C198.918 87.2456 197.464 85.7916 195.67 85.7916C193.876 85.7916 192.422 87.2456 192.422 89.0393C192.422 90.8329 193.876 92.2869 195.67 92.2869Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.371 139.919C41.0971 139.919 46.5496 134.466 46.5496 127.74C46.5496 121.014 41.0971 115.562 34.371 115.562C27.6449 115.562 22.1924 121.014 22.1924 127.74C22.1924 134.466 27.6449 139.919 34.371 139.919Z",
    fill: "url(#paint2_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8283 117.997H63.329C62.8806 117.997 62.5171 118.361 62.5171 118.809V121.516C62.5171 121.964 62.8806 122.327 63.329 122.327H92.8283C93.2767 122.327 93.6402 121.964 93.6402 121.516V118.809C93.6402 118.361 93.2767 117.997 92.8283 117.997Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.96 126.658H63.329C62.8806 126.658 62.5171 127.021 62.5171 127.47V128.011C62.5171 128.459 62.8806 128.823 63.329 128.823H169.96C170.408 128.823 170.772 128.459 170.772 128.011V127.47C170.772 127.021 170.408 126.658 169.96 126.658Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 130.988H63.329C62.8806 130.988 62.5171 131.351 62.5171 131.8V132.341C62.5171 132.789 62.8806 133.153 63.329 133.153H160.938C161.387 133.153 161.75 132.789 161.75 132.341V131.8C161.75 131.351 161.387 130.988 160.938 130.988Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.917 135.318H63.329C62.8806 135.318 62.5171 135.681 62.5171 136.13V136.671C62.5171 137.12 62.8806 137.483 63.329 137.483H151.917C152.365 137.483 152.729 137.12 152.729 136.671V136.13C152.729 135.681 152.365 135.318 151.917 135.318Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.01 130.988C188.803 130.988 190.257 129.534 190.257 127.74C190.257 125.947 188.803 124.493 187.01 124.493C185.216 124.493 183.762 125.947 183.762 127.74C183.762 129.534 185.216 130.988 187.01 130.988Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.331 130.988C206.124 130.988 207.578 129.534 207.578 127.74C207.578 125.947 206.124 124.493 204.331 124.493C202.537 124.493 201.083 125.947 201.083 127.74C201.083 129.534 202.537 130.988 204.331 130.988Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.67 130.988C197.464 130.988 198.918 129.534 198.918 127.74C198.918 125.947 197.464 124.493 195.67 124.493C193.876 124.493 192.422 125.947 192.422 127.74C192.422 129.534 193.876 130.988 195.67 130.988Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.991 130.988C214.784 130.988 216.238 129.534 216.238 127.74C216.238 125.947 214.784 124.493 212.991 124.493C211.197 124.493 209.743 125.947 209.743 127.74C209.743 129.534 211.197 130.988 212.991 130.988Z",
    fill: "#A7B9C8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.054 58.9985H195.688C193.137 58.9985 191.069 61.0665 191.069 63.6175V192.945C191.069 195.496 193.137 197.564 195.688 197.564H273.054C275.605 197.564 277.673 195.496 277.673 192.945V63.6175C277.673 61.0665 275.605 58.9985 273.054 58.9985Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.054 58.9985H195.688C193.137 58.9985 191.069 61.0665 191.069 63.6175V192.945C191.069 195.496 193.137 197.564 195.688 197.564H273.054C275.605 197.564 277.673 195.496 277.673 192.945V63.6175C277.673 61.0665 275.605 58.9985 273.054 58.9985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_223_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.688 58.9985H273.054C275.605 58.9985 277.673 61.0665 277.673 63.6175V73.7788H191.069V63.6175C191.069 61.0662 193.137 58.9985 195.688 58.9985Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.688 58.9985H273.054C275.605 58.9985 277.673 61.0665 277.673 63.6175V73.7788H191.069V63.6175C191.069 61.0662 193.137 58.9985 195.688 58.9985Z",
    fill: "#00252E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.757 64.0792H200.92C200.283 64.0792 199.766 64.5962 199.766 65.234V68.467C199.766 69.1048 200.283 69.6218 200.92 69.6218H226.757C227.395 69.6218 227.912 69.1048 227.912 68.467V65.234C227.912 64.5962 227.395 64.0792 226.757 64.0792Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.973 64.5413H261.507C261.252 64.5413 261.045 64.748 261.045 65.0031C261.045 65.2582 261.252 65.4649 261.507 65.4649H267.973C268.228 65.4649 268.435 65.2582 268.435 65.0031C268.435 64.748 268.228 64.5413 267.973 64.5413Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.973 66.3889H261.507C261.252 66.3889 261.045 66.5957 261.045 66.8508C261.045 67.1058 261.252 67.3126 261.507 67.3126H267.973C268.228 67.3126 268.435 67.1058 268.435 66.8508C268.435 66.5957 268.228 66.3889 267.973 66.3889Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.973 68.2362H261.507C261.252 68.2362 261.045 68.443 261.045 68.698C261.045 68.9531 261.252 69.1599 261.507 69.1599H267.973C268.228 69.1599 268.435 68.9531 268.435 68.698C268.435 68.443 268.228 68.2362 267.973 68.2362Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 96.3464C206.031 96.3464 207.849 94.5289 207.849 92.2868C207.849 90.0448 206.031 88.2273 203.789 88.2273C201.547 88.2273 199.729 90.0448 199.729 92.2868C199.729 94.5289 201.547 96.3464 203.789 96.3464Z",
    fill: "url(#paint3_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 89.0392H212.428C212.29 89.0392 212.179 89.1507 212.179 89.2882V90.2335C212.179 90.371 212.29 90.4825 212.428 90.4825H227.491C227.629 90.4825 227.74 90.371 227.74 90.2335V89.2882C227.74 89.1507 227.629 89.0392 227.491 89.0392Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 91.926H212.428C212.29 91.926 212.179 92.0375 212.179 92.175V92.3988C212.179 92.5363 212.29 92.6478 212.428 92.6478H266.057C266.194 92.6478 266.306 92.5363 266.306 92.3988V92.175C266.306 92.0375 266.194 91.926 266.057 91.926Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 93.3694H212.428C212.29 93.3694 212.179 93.4809 212.179 93.6184V93.8422C212.179 93.9797 212.29 94.0912 212.428 94.0912H261.546C261.684 94.0912 261.795 93.9797 261.795 93.8422V93.6184C261.795 93.4809 261.684 93.3694 261.546 93.3694Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 94.8126H212.428C212.29 94.8126 212.179 94.9241 212.179 95.0616V95.2854C212.179 95.4229 212.29 95.5344 212.428 95.5344H257.036C257.173 95.5344 257.285 95.4229 257.285 95.2854V95.0616C257.285 94.9241 257.173 94.8126 257.036 94.8126Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 133.694C206.031 133.694 207.849 131.877 207.849 129.635C207.849 127.393 206.031 125.575 203.789 125.575C201.547 125.575 199.729 127.393 199.729 129.635C199.729 131.877 201.547 133.694 203.789 133.694Z",
    fill: "url(#paint4_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 126.387H212.428C212.29 126.387 212.179 126.498 212.179 126.636V127.581C212.179 127.719 212.29 127.83 212.428 127.83H227.491C227.629 127.83 227.74 127.719 227.74 127.581V126.636C227.74 126.498 227.629 126.387 227.491 126.387Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 129.274H212.428C212.29 129.274 212.179 129.385 212.179 129.523V129.747C212.179 129.884 212.29 129.996 212.428 129.996H266.057C266.194 129.996 266.306 129.884 266.306 129.747V129.523C266.306 129.385 266.194 129.274 266.057 129.274Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 130.717H212.428C212.29 130.717 212.179 130.829 212.179 130.966V131.19C212.179 131.327 212.29 131.439 212.428 131.439H261.546C261.684 131.439 261.795 131.327 261.795 131.19V130.966C261.795 130.829 261.684 130.717 261.546 130.717Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 132.16H212.428C212.29 132.16 212.179 132.272 212.179 132.409V132.633C212.179 132.771 212.29 132.882 212.428 132.882H257.036C257.173 132.882 257.285 132.771 257.285 132.633V132.409C257.285 132.272 257.173 132.16 257.036 132.16Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 101.488H212.428C212.29 101.488 212.179 101.6 212.179 101.737V102.683C212.179 102.82 212.29 102.932 212.428 102.932H227.491C227.629 102.932 227.74 102.82 227.74 102.683V101.737C227.74 101.6 227.629 101.488 227.491 101.488Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 104.375H212.428C212.29 104.375 212.179 104.487 212.179 104.624V104.848C212.179 104.986 212.29 105.097 212.428 105.097H266.057C266.194 105.097 266.306 104.986 266.306 104.848V104.624C266.306 104.487 266.194 104.375 266.057 104.375Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 105.819H212.428C212.29 105.819 212.179 105.93 212.179 106.068V106.291C212.179 106.429 212.29 106.54 212.428 106.54H261.546C261.684 106.54 261.795 106.429 261.795 106.291V106.068C261.795 105.93 261.684 105.819 261.546 105.819Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 107.262H212.428C212.29 107.262 212.179 107.373 212.179 107.511V107.735C212.179 107.872 212.29 107.984 212.428 107.984H257.036C257.173 107.984 257.285 107.872 257.285 107.735V107.511C257.285 107.373 257.173 107.262 257.036 107.262Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 108.796C206.031 108.796 207.849 106.978 207.849 104.736C207.849 102.494 206.031 100.677 203.789 100.677C201.547 100.677 199.729 102.494 199.729 104.736C199.729 106.978 201.547 108.796 203.789 108.796Z",
    fill: "url(#paint5_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 138.836H212.428C212.29 138.836 212.179 138.948 212.179 139.085V140.031C212.179 140.168 212.29 140.279 212.428 140.279H227.491C227.629 140.279 227.74 140.168 227.74 140.031V139.085C227.74 138.948 227.629 138.836 227.491 138.836Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 141.723H212.428C212.29 141.723 212.179 141.834 212.179 141.972V142.196C212.179 142.333 212.29 142.445 212.428 142.445H266.057C266.194 142.445 266.306 142.333 266.306 142.196V141.972C266.306 141.834 266.194 141.723 266.057 141.723Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 143.166H212.428C212.29 143.166 212.179 143.278 212.179 143.415V143.639C212.179 143.777 212.29 143.888 212.428 143.888H261.546C261.684 143.888 261.795 143.777 261.795 143.639V143.415C261.795 143.278 261.684 143.166 261.546 143.166Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 144.61H212.428C212.29 144.61 212.179 144.721 212.179 144.859V145.082C212.179 145.22 212.29 145.331 212.428 145.331H257.036C257.173 145.331 257.285 145.22 257.285 145.082V144.859C257.285 144.721 257.173 144.61 257.036 144.61Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 146.143C206.031 146.143 207.849 144.326 207.849 142.084C207.849 139.842 206.031 138.024 203.789 138.024C201.547 138.024 199.729 139.842 199.729 142.084C199.729 144.326 201.547 146.143 203.789 146.143Z",
    fill: "url(#paint6_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 113.938H212.428C212.29 113.938 212.179 114.049 212.179 114.187V115.132C212.179 115.269 212.29 115.381 212.428 115.381H227.491C227.629 115.381 227.74 115.269 227.74 115.132V114.187C227.74 114.049 227.629 113.938 227.491 113.938Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 116.824H212.428C212.29 116.824 212.179 116.936 212.179 117.073V117.297C212.179 117.435 212.29 117.546 212.428 117.546H266.057C266.194 117.546 266.306 117.435 266.306 117.297V117.073C266.306 116.936 266.194 116.824 266.057 116.824Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 118.268H212.428C212.29 118.268 212.179 118.379 212.179 118.517V118.741C212.179 118.878 212.29 118.99 212.428 118.99H261.546C261.684 118.99 261.795 118.878 261.795 118.741V118.517C261.795 118.379 261.684 118.268 261.546 118.268Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 119.711H212.428C212.29 119.711 212.179 119.823 212.179 119.96V120.184C212.179 120.321 212.29 120.433 212.428 120.433H257.036C257.173 120.433 257.285 120.321 257.285 120.184V119.96C257.285 119.823 257.173 119.711 257.036 119.711Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 121.245C206.031 121.245 207.849 119.427 207.849 117.185C207.849 114.943 206.031 113.126 203.789 113.126C201.547 113.126 199.729 114.943 199.729 117.185C199.729 119.427 201.547 121.245 203.789 121.245Z",
    fill: "url(#paint7_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 151.286H212.428C212.29 151.286 212.179 151.397 212.179 151.535V152.48C212.179 152.617 212.29 152.729 212.428 152.729H227.491C227.629 152.729 227.74 152.617 227.74 152.48V151.535C227.74 151.397 227.629 151.286 227.491 151.286Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 154.172H212.428C212.29 154.172 212.179 154.284 212.179 154.421V154.645C212.179 154.783 212.29 154.894 212.428 154.894H266.057C266.194 154.894 266.306 154.783 266.306 154.645V154.421C266.306 154.284 266.194 154.172 266.057 154.172Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 155.616H212.428C212.29 155.616 212.179 155.727 212.179 155.865V156.089C212.179 156.226 212.29 156.338 212.428 156.338H261.546C261.684 156.338 261.795 156.226 261.795 156.089V155.865C261.795 155.727 261.684 155.616 261.546 155.616Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 157.059H212.428C212.29 157.059 212.179 157.17 212.179 157.308V157.532C212.179 157.669 212.29 157.781 212.428 157.781H257.036C257.173 157.781 257.285 157.669 257.285 157.532V157.308C257.285 157.17 257.173 157.059 257.036 157.059Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 158.593C206.031 158.593 207.849 156.775 207.849 154.533C207.849 152.291 206.031 150.474 203.789 150.474C201.547 150.474 199.729 152.291 199.729 154.533C199.729 156.775 201.547 158.593 203.789 158.593Z",
    fill: "url(#paint8_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 171.042C206.031 171.042 207.849 169.224 207.849 166.982C207.849 164.74 206.031 162.923 203.789 162.923C201.547 162.923 199.729 164.74 199.729 166.982C199.729 169.224 201.547 171.042 203.789 171.042Z",
    fill: "url(#paint9_linear_223_395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 163.735H212.428C212.29 163.735 212.179 163.846 212.179 163.984V164.929C212.179 165.067 212.29 165.178 212.428 165.178H227.491C227.629 165.178 227.74 165.067 227.74 164.929V163.984C227.74 163.846 227.629 163.735 227.491 163.735Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 166.622H212.428C212.29 166.622 212.179 166.733 212.179 166.871V167.094C212.179 167.232 212.29 167.343 212.428 167.343H266.057C266.194 167.343 266.306 167.232 266.306 167.094V166.871C266.306 166.733 266.194 166.622 266.057 166.622Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 168.065H212.428C212.29 168.065 212.179 168.176 212.179 168.314V168.538C212.179 168.675 212.29 168.787 212.428 168.787H261.546C261.684 168.787 261.795 168.675 261.795 168.538V168.314C261.795 168.176 261.684 168.065 261.546 168.065Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 169.508H212.428C212.29 169.508 212.179 169.62 212.179 169.757V169.981C212.179 170.118 212.29 170.23 212.428 170.23H257.036C257.173 170.23 257.285 170.118 257.285 169.981V169.757C257.285 169.62 257.173 169.508 257.036 169.508Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 176.184H212.428C212.29 176.184 212.179 176.295 212.179 176.433V177.378C212.179 177.516 212.29 177.627 212.428 177.627H227.491C227.629 177.627 227.74 177.516 227.74 177.378V176.433C227.74 176.295 227.629 176.184 227.491 176.184Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057 179.071H212.428C212.29 179.071 212.179 179.182 212.179 179.32V179.544C212.179 179.681 212.29 179.793 212.428 179.793H266.057C266.194 179.793 266.306 179.681 266.306 179.544V179.32C266.306 179.182 266.194 179.071 266.057 179.071Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.546 180.514H212.428C212.29 180.514 212.179 180.626 212.179 180.763V180.987C212.179 181.124 212.29 181.236 212.428 181.236H261.546C261.684 181.236 261.795 181.124 261.795 180.987V180.763C261.795 180.626 261.684 180.514 261.546 180.514Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.036 181.957H212.428C212.29 181.957 212.179 182.069 212.179 182.206V182.43C212.179 182.568 212.29 182.679 212.428 182.679H257.036C257.173 182.679 257.285 182.568 257.285 182.43V182.206C257.285 182.069 257.173 181.957 257.036 181.957Z",
    fill: "#E1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.789 183.491C206.031 183.491 207.849 181.674 207.849 179.432C207.849 177.19 206.031 175.372 203.789 175.372C201.547 175.372 199.729 177.19 199.729 179.432C199.729 181.674 201.547 183.491 203.789 183.491Z",
    fill: "url(#paint10_linear_223_395)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_223_395",
    x: -7.29346,
    y: -7.2937,
    width: 279.811,
    height: 182.382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_223_395",
    x: -7.29346,
    y: -7.2937,
    width: 279.811,
    height: 37.3207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_223_395",
    x: 182.069,
    y: 49.9985,
    width: 104.604,
    height: 156.566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_223_395",
    x: 182.069,
    y: 49.9985,
    width: 104.604,
    height: 32.7803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.145098 0 0 0 0 0.180392 0 0 0 0.181839 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_395"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_395",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_395",
    x1: 26.0404,
    y1: 34.2442,
    x2: 41.9369,
    y2: 71.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_223_395",
    x1: 34.371,
    y1: 76.8606,
    x2: 34.371,
    y2: 101.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_223_395",
    x1: 29.2494,
    y1: 115.562,
    x2: 44.1626,
    y2: 142.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9952FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_223_395",
    x1: 200.932,
    y1: 86.4117,
    x2: 205.9,
    y2: 97.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_223_395",
    x1: 200.932,
    y1: 123.759,
    x2: 205.9,
    y2: 135.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_223_395",
    x1: 203.789,
    y1: 100.677,
    x2: 203.789,
    y2: 108.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_223_395",
    x1: 203.789,
    y1: 138.024,
    x2: 203.789,
    y2: 146.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_223_395",
    x1: 202.082,
    y1: 113.126,
    x2: 207.053,
    y2: 122.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9952FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_223_395",
    x1: 202.082,
    y1: 150.474,
    x2: 207.053,
    y2: 159.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9952FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_223_395",
    x1: 200.932,
    y1: 161.107,
    x2: 205.9,
    y2: 172.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF52C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_223_395",
    x1: 203.789,
    y1: 175.372,
    x2: 203.789,
    y2: 183.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280.108,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMockupsMobile);
export default __webpack_public_path__ + "static/media/illustration-mockups-mobile.93bae27780217f0d4972f7d78fa9b95b.svg";
export { ForwardRef as ReactComponent };